import * as d3 from 'd3-selection'

export default function (prevSerieTypes) {
  return function (selection) {
    selection.each(function (plotData) {
      let series = d3.select(this)
                     .selectAll('g.serie:not(.serie-transitioning)')
                     .data(d => d.series, d => d.id)
        , _series = series.enter()
                          .append('g')
                          .merge(series)
                          .order()

      _series.attr('data-serie-type', d => d.type) // Store the type of serie, needed for animations
             .attr('class', d => {
               let prev = prevSerieTypes[d.id] ? prevSerieTypes[d.id].type : ''
               // Maintain the previous serie type class if this serie changed
               // types. It will removed after the transition ends
               let clazzes = new Set() // Set to prevent duplicate class names
               clazzes.add(d.type)

               if (prev) {
                 clazzes.add(prev)
               }

               if (clazzes.size > 1) {
                 // Changing type
                 clazzes.add(`serie-prev-${prev}`) // Used to figure out how groups of series should transition
               }

               if (d.deemphasize){
                  clazzes.add('deemphasize')
               }

               return `serie is-deemphasizable ${d.color || ''} ${Array.from(clazzes).join(' ')}`
             })

      selection.end().then(() => {
        // When the transitions have finished, we want to remove any old class types
        _series.each(function (d) {
          let prev = prevSerieTypes[d.id]
          if (prev && prev.type !== d.type) {
            d3.select(this).classed(prev.type, false) // Remove the old class type from the serie
          }
          if (prev) {
            // Used just for transitions, remove
            d3.select(this).classed(`serie-prev-${prev.type}`, false)
          }
        })

      }).catch(() => {
        // Swallow. Duplicate transitions running so the original transition was interrupted
      })

      series.exit()
            .classed('serie-exit', true)
            .transition(selection)
            .remove()
    })
  }
}
